import {
  __spreadProps,
  __spreadValues
} from "./chunk-CWMXXUWU.js";

// src/styles/themeDefaults/loading.tsx
var loadingThemeBase = {
  defaultIconName: "LoadingSpinner",
  kinds: {}
};
var defaultLoadingTheme = __spreadProps(__spreadValues({}, loadingThemeBase), {
  kinds: {
    primary: {
      defaultIconName: "LoadingSpinner"
    }
  }
});

export {
  loadingThemeBase,
  defaultLoadingTheme
};
